import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import { ISelect } from '../../../../../shared/types/shared';
import {
    FunctionarySwitch,
    Switch,
} from '../../../../../shared/types/modules/switch';
import {
    asyncCreateSwitch,
    asyncGetSwitch,
    asyncUpdateSwitch,
} from '../../../../../services/switch.service';
import { SWITCH, SWITCH_DETAIL } from '../../../../../routes/paths';

export const useSwitchForm = () => {
    const navigate = useNavigate();
    const { idSwitch } = useParams();
    const { idAccount } = useParams();
    const [switchDetail, setSwitch] = useState<Switch>();
    const [functionarySwitchDetail, setFunctionarySwitch] =
        useState<FunctionarySwitch>();
    const [loading, setLoading] = useState(false);
    const [formikSwitch, setFormikSwitch] = useState<FormikProps<Switch>>();
    const [formikSwitchFunctionaryInfo, setFormikSwitchFunctionaryInfo] =
        useState<FormikProps<FunctionarySwitch>>();

    const isValidForm =
        formikSwitch?.isValid && formikSwitchFunctionaryInfo?.isValid;

    const handleSubmit = async () => {
        await formikSwitch?.submitForm();
        await formikSwitchFunctionaryInfo?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: Switch = cleanObj(formikSwitch?.values) || {};
        const dataFunctionarySwitch: FunctionarySwitch =
            cleanObj(formikSwitchFunctionaryInfo?.values) || {};
        data.account = switchDetail?.account?.id || idAccount;

        let res: Switch | undefined = undefined;

        try {
            if (switchDetail && switchDetail.id)
                res = await asyncUpdateSwitch(
                    switchDetail.id,
                    data,
                    dataFunctionarySwitch
                );
            else res = await asyncCreateSwitch(data, dataFunctionarySwitch);
        } catch (error) {}

        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! El conmutador se ${
                    switchDetail && switchDetail.id ? 'actualizo' : 'creó'
                } satisfactoriamente con ID: ${res.id}`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${SWITCH_DETAIL}/${res.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    switchDetail && switchDetail.id ? 'actualizar' : 'crear'
                } el caso. Por favor, asegúrate de diligenciar los datos correctamente e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    const handleClean = () => {
        formikSwitch?.resetForm();
        formikSwitchFunctionaryInfo?.resetForm();
    };

    useEffect(() => {
        if (Boolean(idSwitch?.trim())) {
            setLoading(true);
            asyncGetSwitch(idSwitch?.trim())
                .then((res) => {
                    if (!res || !res.id) navigate(SWITCH);

                    [res].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });

                    const functionaryInfo: FunctionarySwitch = {
                        id: res?.idFunctionaryInfo,
                        area: res?.functionaryInfoArea,
                        functionary: res?.functionaryInfoFunctionary,
                        emailFunctionary: res?.functionaryInfoEmail,
                        extFunctionary: res?.functionaryInfoExtension,
                        functionaryAttendedCall:
                            res?.functionaryInfoAttendedCall,
                        templateEmail: res?.functionaryInfoTemplateEmail,
                    };

                    setFunctionarySwitch(functionaryInfo);
                    setSwitch(res);
                })
                .finally(() => setLoading(false));
        }
    }, [idSwitch]);

    return {
        switchDetail,
        functionarySwitchDetail,
        idAccount,
        loading,
        isValidForm,
        handleSubmit,
        handleClean,
        formikSwitch,
        setFormikSwitch,
        setFormikSwitchFunctionaryInfo,
    };
};
